import React from "react";
import Close from "images/close_grey.svg";
import type { WorkingFilters } from "components/types/working-filters";
import { useDisplayedFilters, type DisplayedFilter } from "hooks/use-displayed-filters";

export type SelectedFiltersProps = {
  onClearFilters: () => void;
  onClearSingleFilter: (filter: { filterGroupKey: keyof WorkingFilters; name: string; selected: boolean }) => void;
};

const SelectedFilters = (props: SelectedFiltersProps) => {
  const { displayedFilters, displayedFilterCount } = useDisplayedFilters();

  const hasSelectedFilters = displayedFilterCount > 0;

  const disabledClass = hasSelectedFilters ? "" : "text-lightGray";

  const filterCountCopy = hasSelectedFilters ? `Filters (${displayedFilterCount}):` : "Filters:";

  const clearSingleFilter = (filter: DisplayedFilter) => {
    props.onClearSingleFilter({
      filterGroupKey: filter.filterKey,
      name: filter.filterValue,
      selected: false,
    });
  };

  return (
    <div className="flex flex-col pt-6 pb-0 md:py-4 gap-2">
      <div className="flex justify-between">
        <p className="text-lg">{filterCountCopy}</p>
        <button
          className={`text-sm underline font-medium ${disabledClass}`}
          onClick={props.onClearFilters}
          disabled={!hasSelectedFilters}
          data-test-id="clear-all-filters">
          Clear
        </button>
      </div>
      {hasSelectedFilters && (
        <ul className="flex justify-start items-center gap-2 flex-wrap">
          {displayedFilters.map(filter => (
            <li key={filter.filterValue}>
              <button
                key={filter.filterValue}
                className="rounded-3xl py-1.5 pl-3 pr-1.5 flex items-center justify-center text-sm bg-offWhite w-full"
                data-test-id={`selected-filter-${filter.filterValue}`}
                onClick={() => clearSingleFilter(filter)}>
                {filter.displayedValue}
                <Close className="w-6 h-6" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectedFilters;
